import React, { FC } from 'react'

import { Tags } from 'components'
import { FilterWrapper } from '..'

import { FILTER_FIELDS, PROJECT_DETAILS_FILTER_INIT_VALUES } from 'shared/consts/filter'

import { FilterProjectDetailProps } from './FilterProjectDetail.props'

const FilterProjectDetail: FC<FilterProjectDetailProps> = ({ filterEntities, tags, projectFeedTotal }) => (
  <FilterWrapper
    total={`${projectFeedTotal} stories`}
    initialValues={PROJECT_DETAILS_FILTER_INIT_VALUES}
    defaultValue={PROJECT_DETAILS_FILTER_INIT_VALUES}
    filterEntities={filterEntities}
    render={({ updateValue, resetValues, shouldBeReset, values }) => (
      <div className="project-filters-container">
        <Tags
          reset={shouldBeReset}
          tagsList={tags}
          onSelect={updateValue(FILTER_FIELDS.TAGS)}
          onReset={resetValues}
          initialTagsValue={values.tags}
          dataTest="project_details-filters-tags"
        />
      </div>
    )}
  />
)

export default FilterProjectDetail
